import React from 'react';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
);

export const options = {
	responsive: true,
	interaction: {
		mode: 'index',
		intersect: false,
	},
	stacked: false,
	plugins: {
		legend: {
			display: false,
		},
		title: {
			display: false,
		},
	},
	scales: {
		x: {
			display: false,
		},
		y: {
			type: 'linear',
			display: false,
			position: 'left',
			grid: {
				drawOnChartArea: false,
			},
			title: {
				display: false,
				text: 'Total Value',
				font: {
					size: 14,
					weight: '500',
					family: "'Inter', sans-serif",
				},
				color: 'rgba(14, 76, 136, 1)',
			},
		},
	},
};

export function ReclaimDashboardScoreChart({ data }) {
	// If data is not provided, use an empty array to avoid errors
	const chartDataArray = Array.isArray(data) ? data : [];

	// Sort by year to ensure correct order
	const sortedData = [...chartDataArray].sort((a, b) => a.year - b.year);

	// Extract labels and data points
	const labels = sortedData.map(item => item.year.toString());
	const balanceSums = sortedData.map(item => item.balanceSum);

	const chartData = {
		labels,
		datasets: [
			{
				label: 'Balance Sum',
				data: balanceSums,
				borderColor: 'rgb(14, 76, 136)',
				backgroundColor: 'rgba(14, 76, 136, 1)',
				pointRadius: 5,
				pointBorderColor: '#fff',
				yAxisID: 'y',
				tension: 0.4,
			},
		],
	};

	console.log(chartData, "chart data");
	return <Line options={options} data={chartData} />;
}

export default ReclaimDashboardScoreChart;
